import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { LzTOpenObject } from "@lz-types/types";

export interface LzPInfoBox {
    heading?: string,
    route?: string,
    routeParams?: LzTOpenObject;
    routeTitle?: any,
    customBottomLink?: any,
    customAboveCount?: any,
    count?: number,
    isCountCompact?: boolean,
    customBelowCount?: any,
    elevation?: number,
    primary?: boolean,
    secondary?: boolean,
    purple?: boolean,
    blue?: boolean,
    pink?: boolean,
    orange?: boolean,
    green?: boolean,
    red?: boolean,
    light?: boolean,
    dark?: boolean,
    listHeader?: boolean,
}

const LzXInfoBox = (props: LzPInfoBox) => {
    return (
        <Paper
            className={
                'lz-info-box'
                + (props.primary ? ' primary' : '')
                + (props.secondary ? ' secondary' : '')
                + (props.purple ? ' purple' : '')
                + (props.blue ? ' blue' : '')
                + (props.pink ? ' pink' : '')
                + (props.orange ? ' orange' : '')
                + (props.green ? ' green' : '')
                + (props.red ? ' red' : '')
                + (props.light ? ' light' : '')
                + (props.dark ? ' dark' : '')
                + (props.listHeader ? ' list-header' : '')
            }
            elevation={props.elevation || 2}
        >
            {typeof props.heading !== 'undefined' && <h2>{props.heading}</h2>}
            {typeof props.customAboveCount !== 'undefined' &&
                <div className="lz-info-box-custom-above-count">{props.customAboveCount}</div>
            }
            {typeof props.count !== 'undefined' && <big className={'' + (props.isCountCompact ? 'lz-compact' : '')}>{props.count || 0}</big>}
            {typeof props.customBelowCount !== 'undefined' &&
                <div className="lz-info-box-custom-below-count">{props.customBelowCount}</div>
            }
            {typeof props.route !== 'undefined' &&
                <Link
                    to={props.route}
                    state={props.routeParams}
                    className="lz-info-box-bottom-link"
                >{props.routeTitle || 'Details'} < DoubleArrowIcon fontSize="small" /></Link>
            }
            {props.customBottomLink}
        </Paper>
    );
};

export default LzXInfoBox;
